module.exports = __webpack_public_path__ + "img/Oracles_wc.b93f3b80.svg";